import defaultContent from "./common";

export default () => defaultContent();
